import React from 'react';
import { MapPin, Phone, Clock, Droplet } from 'lucide-react';
import { Button } from '../ui/button';

export const MennecyModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      data-testid="mennecy-modal"
    >
      <div className="relative bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        {/* BOUTON FERMER */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-20 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100"
          data-testid="mennecy-modal-close"
          aria-label="Fermer"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* HEADER PRESSING */}
        <div className="bg-green-600 text-white p-8">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-3xl font-bold">Pressing AQUABLUENET</h2>
            <div className="bg-white text-green-600 px-4 py-2 rounded-full text-sm font-bold">
              91540
            </div>
          </div>
          <p className="text-xl text-green-100">Mennecy</p>
          <p className="text-green-200 mt-2">Intermarché - Rue Jean Cocteau</p>
        </div>

        {/* CONTENU */}
        <div className="p-8 space-y-6">
          <div className="flex items-start gap-4">
            <MapPin className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Adresse</p>
              <p className="text-gray-600">
                Intermarché<br />
                Rue Jean Cocteau<br />
                91540 Mennecy
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <Phone className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Téléphone</p>
              <a href="tel:0984509942" className="text-green-600 hover:underline text-xl font-medium">
                09 84 50 99 42
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <Clock className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Horaires d'ouverture</p>
              <p className="text-gray-600 text-lg">
                <strong>Mardi - Samedi</strong><br />
                9h30 - 19h00
              </p>
              <p className="text-sm text-red-600 font-medium mt-1">Fermé Dimanche et Lundi</p>
            </div>
          </div>

          <div className="bg-green-50 border-2 border-green-600 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <svg className="h-6 w-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="font-bold text-green-700 text-lg">Carte CleanWay (5àSec business) acceptée</p>
            </div>
            <p className="text-gray-600">Utilisez votre carte <strong>CleanWay</strong> dans ce pressing</p>
          </div>

          <div className="bg-blue-50 border-2 border-blue-600 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Droplet className="h-6 w-6 text-blue-600" />
              <p className="font-bold text-blue-700 text-lg">Technologie Lagoon écologique</p>
            </div>
            <p className="text-gray-600">Nettoyage 0% Perchlo, 100% naturel</p>
          </div>

          <Button
            className="w-full bg-green-600 hover:bg-green-700 text-white py-6 text-lg"
            onClick={() => window.open('https://www.google.com/maps?q=Intermarché+Rue+Jean+Cocteau+Mennecy+91540', '_blank')}
            data-testid="mennecy-modal-map-btn"
          >
            <MapPin className="mr-2 h-5 w-5" />
            Obtenir l'itinéraire vers Mennecy
          </Button>
        </div>
      </div>
    </div>
  );
};
